import * as actionTypes from 'store/actions/actionTypes';
import { store } from 'index.js';

const initState = {
  tiles: [],
  stone: [],
  mosaic: [],
  wood: [],
  vinyl: [],
  countertop: [],
};

export default (state = initState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.WRITE_CART_END:
      const { productType, records } = action;
      newState[productType] = records;
      return newState;
    case actionTypes.TRIM_CART_END:
      const { product_type, product_id } = action;
      newState[product_type] = state[product_type].filter(id => id !== product_id);
      return newState;
    case actionTypes.CLEAR_CART_END:
      return initState;
    default:
      return state;
  }
};

export const parseTotal = cart => {
  return (
    cart['tiles'].length +
    cart['stone'].length +
    cart['mosaic'].length +
    cart['wood'].length +
    cart['vinyl'].length +
    cart['countertop'].length
  );
};

// convert array of id into product objects array
export const parseObject = cart => {
  const { product } = store.getState();
  const productReference = product.all;
  const cartKeys = Object.keys(cart);
  const newCart = { ...cart };
  for (const key of cartKeys) {
    if (cart[key].length === 0) continue;
    newCart[key] = cart[key].map(id => {
      const product = productReference[key];
      return Object.assign({}, product.find(p => p.id === id));
    });
  }

  return newCart;
};

// flatten multiple arrays of products into a single array
// for easier usage in Cart
export const flattenProductTypes = cart => {
  const cartKeys = Object.keys(cart);
  let productArray = [];
  for (const key of cartKeys) {
    if (cart[key].length === 0) continue;
    productArray = productArray.concat(
      cart[key].map(obj => {
        const newObj = { ...obj };
        newObj['product_type'] = key;
        return newObj;
      }),
    );
  }
  return productArray;
};



// WEBPACK FOOTER //
// ./src/store/reducers/cart.js